export default class Device {
  static isiOS() {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  }
}
